import HeroImage from "../HeroImage";

export default function LoginImage() {
    return (
        <HeroImage imageUrl="/img/cycling_hero.jpg" paragraph="Welcome to the world of windpuls! Please login to your account to experience the most sophisticated wind and weather measurement and analytics on the market." />
    )
}